import { render, staticRenderFns } from "./UpcomingHolidayWidget.vue?vue&type=template&id=d34aa904&"
import script from "./UpcomingHolidayWidget.vue?vue&type=script&lang=js&"
export * from "./UpcomingHolidayWidget.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingHolidayWidget.vue?vue&type=style&index=0&id=d34aa904&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports